/* eslint-disable @typescript-eslint/naming-convention */
import { createSlice } from '@reduxjs/toolkit';
import { noop } from 'lodash';
import { Report } from 'src/dao/reportClient';
import { ClientDataApi } from 'src/services/configuration/codecs/confdefnView';
import { getMutations, getNotices, uploadMutationTemplate } from './BulkImport.actions';

export interface BulkImportMutation extends Report {
  attributeDefnsImpact?: string[];
  systemTableImpact?: string[];
  floorsetApi?: ClientDataApi;
}
export interface BulkImportNotice {
  result: {
    columns: string[];
    messages: Record<string, unknown>[];
  };
  transactionId: string;
  statistics?: {
    uploaded: number;
    rejected: number;
    validated: number;
  };
  validationMsg?: {
    rowId: number;
    message: string;
  }[];
  resultWorkbookPath?: string;
}

export enum BulkImportLoadingState {
  idle,
  mutationsLoading,
  templateLoading,
  templateUploading,
  noticesLoading,
}

export interface BulkImportSlice {
  mutations: BulkImportMutation[] | undefined;
  bulkImportLoadingState: BulkImportLoadingState;
}

const initialState: BulkImportSlice = {
  mutations: undefined,
  bulkImportLoadingState: BulkImportLoadingState.idle,
};

const bulkImportReducer = createSlice({
  name: 'BulkImport',
  initialState: initialState,
  reducers: {
    cleanUp() {
      return initialState;
    },
    onShowView() {
      noop();
    },
  },
  extraReducers: (builder) => {
    //#region getMutations actions
    builder.addCase(getMutations.pending, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.mutationsLoading;
      state.mutations = undefined;
    });
    builder.addCase(getMutations.fulfilled, (state, action) => {
      state.bulkImportLoadingState = BulkImportLoadingState.idle;
      state.mutations = action.payload;
    });
    builder.addCase(getMutations.rejected, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.idle;
    });
    //#endregion
    //#region uploadBulkImport actions
    builder.addCase(uploadMutationTemplate.pending, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.templateUploading;
    });
    builder.addCase(uploadMutationTemplate.fulfilled, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.idle;
    });
    builder.addCase(uploadMutationTemplate.rejected, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.idle;
    });
    //#endregion
    //#region getNotices actions
    builder.addCase(getNotices.pending, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.noticesLoading;
    });
    builder.addCase(getNotices.fulfilled, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.idle;
    });
    builder.addCase(getNotices.rejected, (state) => {
      state.bulkImportLoadingState = BulkImportLoadingState.idle;
    });
    //#endregion
  },
});

export const { cleanUp } = bulkImportReducer.actions;
export default bulkImportReducer.reducer;
